export class GetProductsShowcaseAction {
  static readonly type = '[Products] Load products showcase for the cards';
}

export class GetProductsAction {
  static readonly type = '[Products] Load all products';
}
